import { render, staticRenderFns } from "./ScreenCalibrationMonitor.vue?vue&type=template&id=264613b6"
import script from "./ScreenCalibrationMonitor.vue?vue&type=script&lang=js"
export * from "./ScreenCalibrationMonitor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports